import React, { useState } from 'react'
import ResetPasswordForm from 'src/components/ResetPasswordForm/ResetPasswordForm'
import SvgActionRequired from 'src/components/Svgs/SvgActionRequired'
import UnauthedBoxContainer from 'src/components/UnauthedBoxContainer/UnauthedBoxContainer'
import UnauthedPageContainer from 'src/components/UnauthedPageContainer/UnauthedPageContainer'
import { useTranslate } from 'src/localization/Trns'

const ResetPassword: React.FC = () => {
  const translate = useTranslate()

  const [topRightImage, setTopRightImage] = useState(<SvgActionRequired />)
  return (
    <UnauthedPageContainer>
      <UnauthedBoxContainer topRightImage={topRightImage}>
        <ResetPasswordForm
          title={translate('Forgot Password')}
          setTopRightImage={setTopRightImage}
        />
      </UnauthedBoxContainer>
    </UnauthedPageContainer>
  )
}

export default ResetPassword
